import React from 'react'

import { Charts, FilingsOverTime, TransformLine } from '../types'
import { ChartProps } from '../types'
import LineChart from './LineChart'
import LineChartSkeletonLoader from './LineChartSkeletonLoader'
import PlatformChartContainer from './PlatformChartContainer'

const transform: TransformLine<FilingsOverTime> = (datum) =>
  datum.map(({ data, ...item }) => ({
    ...item,
    data: data
      .sort((current, next) => current.year - next.year)
      .map(({ filings, year }) => ({
        x: year,
        y: filings,
      })),
  }))

const Filings: React.FC<ChartProps> = (props) => (
  <PlatformChartContainer
    chart={Charts.FilingsOverTime}
    exportableConfig={{
      filename: 'filings',
      getData: (data) => {
        const years = data[0].data.map(({ year }) => year)

        return data.map((item) => {
          const datapoints = years.map((year) =>
            item.data.find(({ year: datumYear }) => year === datumYear)
          )

          return [item.id, ...datapoints.map((datapoint) => (datapoint ? datapoint.filings : ''))]
        })
      },
      getHeader: (data) => data[0].data.map(({ year }) => year),
    }}
    skeleton={LineChartSkeletonLoader}
    title="Filings"
    {...props}
  >
    {({ data: raw, ...dimensions }) => {
      const data = transform(raw)

      return (
        <LineChart
          {...dimensions}
          axisBottom={{
            legend: 'Filing Year',
          }}
          axisLeft={{
            format: '~s',
            legend: 'Filings',
          }}
          data={data}
          tooltipFormat=","
        />
      )
    }}
  </PlatformChartContainer>
)

export { transform }
export default Filings
